import React from 'react';
import { Modal, Alert } from 'antd';
import { withTranslation } from 'react-i18next';


const VerifiedAgencyInfoModal = ({ isVisible, hide, message = null, t, onContinue = null }) => {

    const handleOk = () => {
        if (onContinue) onContinue();
        hide();
    };

    return (
        <>
            <Modal
                title={t("Limited functionality")}
                visible={isVisible}
                onOk={handleOk}
                onCancel={hide}
                okText={onContinue ? t('Continue') : 'Ok'}
                cancelButtonProps={{ style: onContinue ? {} : { display: "none" } }}
            >
                <div style={{margin:"24px"}}>
                    {message ? <p>{message}</p> : <></>}
                    {!onContinue && <p>{t("Verified agencies text")} <a href='https://help.latinad.com/faq-agencias/#hfaq-post-4111' target="_blank">help.latinad.com</a></p>}
                </div>
            </Modal>
        </>
    )
};

export default withTranslation()(VerifiedAgencyInfoModal);